// Window width / height
const win = {
	w: window.innerWidth,
	h: window.innerHeight,
}
const setWin = () => {
	win.w = window.innerWidth
	win.h = window.innerHeight
}


// Set Vh
const setVh = () => {
	document.documentElement.style.setProperty('--vh', win.h / 100 + 'px')
}

// Set Vw
const setVw = () => {
	document.documentElement.style.setProperty('--vw', win.w / 100 + 'px')
}


// Set header height
const setHeaderHeight = () => {
	const siteHeader = document.querySelector('.site-header')
	document.documentElement.style.setProperty('--header-height', siteHeader.offsetHeight + 'px')
}


// Is touch device
const isTouchDevice = "ontouchstart" in document.documentElement


// Disable / Enable scroll
const disableScroll = () => {
	document.body.classList.add('disable-scroll')
}

const enableScroll = () => {
	document.body.classList.remove('disable-scroll')
}

export {
	win,
	setWin,
	setVh,
	setVw,
	setHeaderHeight,
	disableScroll,
	enableScroll,
	isTouchDevice,
}